"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { ProductCard } from '@/components/product/ProductCard';
import type { ProductCardProduct } from '@/components/product/ProductCard';
interface ProductOptionsVisualProps {
  products: ProductCardProduct[];
}
export function ProductOptionsVisual(t0) {
  const $ = _c(17);
  const {
    products
  } = t0;
  const scrollerRef = useRef(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = scrollerRef.current;
      if (!el) {
        return;
      }
      setCanScrollPrev(el.scrollLeft > 4);
      setCanScrollNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updateScrollState = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      updateScrollState();
      const el_0 = scrollerRef.current;
      if (!el_0) {
        return;
      }
      el_0.addEventListener("scroll", updateScrollState, {
        passive: true
      });
      window.addEventListener("resize", updateScrollState);
      return () => {
        el_0.removeEventListener("scroll", updateScrollState);
        window.removeEventListener("resize", updateScrollState);
      };
    };
    t3 = [updateScrollState];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = direction => {
      const el_1 = scrollerRef.current;
      if (!el_1) {
        return;
      }
      const firstCard = el_1.querySelector("[data-slider-card]");
      const cardWidth = firstCard instanceof HTMLElement ? firstCard.offsetWidth : 280;
      el_1.scrollBy({
        left: direction * (cardWidth + 16),
        behavior: "smooth"
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const scrollByCard = t4;
  if (products.length === 0) {
    return null;
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="related-products-header">Product Options</div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== canScrollPrev) {
    t6 = canScrollPrev && <button type="button" aria-label="Previous product" onClick={() => scrollByCard(-1)} className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white shadow-md border border-gray-200 hover:bg-gray-50 transition-colors"><ChevronLeft className="w-5 h-5 text-gray-700" /></button>;
    $[5] = canScrollPrev;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== canScrollNext) {
    t7 = canScrollNext && <button type="button" aria-label="Next product" onClick={() => scrollByCard(1)} className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-10 w-10 h-10 items-center justify-center rounded-full bg-white shadow-md border border-gray-200 hover:bg-gray-50 transition-colors"><ChevronRight className="w-5 h-5 text-gray-700" /></button>;
    $[7] = canScrollNext;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== products) {
    t8 = products.map(_temp);
    $[9] = products;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t8) {
    t9 = <div ref={scrollerRef} className="flex gap-4 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-4 product-options-scroller" role="list" aria-label="Product options">{t8}</div>;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== t9) {
    t10 = <section id="product-options-visual" className="related-products-section">{t5}<div className="relative">{t6}{t7}{t9}</div></section>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
function _temp(product) {
  return <div key={product.id} data-slider-card={true} role="listitem" className="flex-none snap-start w-[calc(50%-0.5rem)] sm:w-[calc(33.333%-0.75rem)] md:w-[calc(25%-0.75rem)] lg:w-[calc(25%-0.75rem)]"><ProductCard product={product} /></div>;
}